<template>
  <splitpanes class="default-theme">
    <pane min-size="15" size="20">
      <div style="width: 100%;height: 100%" v-if="this.componentParam !== 'my_course_study'">
        <div class="card-header" style="width: 100%;border: solid 1px lightgrey">
          <span style="margin: 5px;font-weight: bold">内训目录</span>
          <el-icon :size="24" @click="refreshNode(currentDir.id)" style="margin-top: 5px">
            <ElIconRefresh class="el-icon-refresh"/>
          </el-icon>
        </div>

        <el-tree
            ref="tree"
            :data="dirData"
            :props="defaultProps"
            node-key="id"
            :load="loadNode"
            lazy
            @node-click="nodeClickHandle"
            highlight-current
            :expand-on-click-node="false"
            min-height="500px"
            style="height: 100%;overflow: auto"
        >
        </el-tree>
      </div>
    </pane>

    <pane min-size="50" style="background-color: white">
      <div class="card-header"
           style="width: 100%;padding: 3px;border: solid 1px lightgrey;background-color: whitesmoke">
        <el-row style="width: 100%">
          <el-col :span="20">
            <span width="100%" class="department-name">{{ currentDir.full_path }}</span>
          </el-col>
        </el-row>
      </div>
      <div class="mainStyle">
        <div class="list">
          <div v-for="item in courseList" :key="item.id" class="list-item" @click="courseDetail(item)">
            <div class="image-style">
              <el-image style="width: 260px;height: 320px;" :src="item.url"/>
              <span class="nameSpan">{{ item.name }}</span>
              <div class="title-name">
                <span>{{ item.create_time }}</span>
                <div style="margin-left: 20px;">
                  <img src="/tmp/courseDetail/goodWhite.png" alt=""/>
                  <span style="margin-left: 10px;">{{ item.likeSum }}</span>
                </div>
                <div style="margin-left: 10px;">
                  <img src="/tmp/courseDetail/gk.png" alt=""/>
                  <span style="margin-left: 10px;">{{ item.watchSum }}</span>
                </div>
                <div style="margin-left: 10px;">
                  <img src="/tmp/courseDetail/comment.png" alt=""/>
                  <span style="margin-left: 10px;">{{ item.commentSum }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </pane>

  </splitpanes>
</template>

<script>

import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "CourseStudy",
  components: { Splitpanes, Pane},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {

      dirData: [],
      currentDir: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      loading: false,
      currentCourse: {},
      courseList: [],
    }
  },

  mounted() {
    this.getCourseData();
    // this.loadDirTree();

  },
  methods: {

    refreshNode(nodeId) {
      if (nodeId && nodeId.length > 0) {
        this.$refs.tree.store.nodesMap[this.currentDir.id].loaded = false;
        this.$refs.tree.store.nodesMap[this.currentDir.id].loadData();
      } else {
        this.loadDirTree()
      }
    },
    //--勾选--
    nodeClickHandle(currentRow) {
      this.currentDir = currentRow
      this.currentPage = 1
      this.getCourseData()
    },

    async loadDirTree() {
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: 'inner_train', parent_id: ''})
      this.dirData = data;
    },

    async loadNode(node, resolve) {
      console.log("node.id=" + node.data.id);
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: 'inner_train', parent_id: node.data.id})
      resolve(data)
    },

    //查询课程数据
    async getCourseData() {
      //查询数据
      let list = await this.$http('ihtCourseService.getCourse', this.currentDir)
      console.log("courseList-=", list)
      if (!list) {
        return this.$message.error("获取课程失败")
      }
      this.courseList = list;

    },

    courseDetail(item) {
      this.$store.dispatch('core/openWindow', {
        component: 'iht/CourseDetail',
        componentParam: 'course_study',
        parentData: item,
        name: item.name,
        max: true
      })
    }
  },

}
</script>

<style lang="less" scoped>

.mainStyle {
  display: flex;
  justify-content: left;
  height: 100%;
  overflow-y: auto;
}

.list {
  display: flex;
  flex-wrap: wrap;

}

.list .list-item {
  width: 278px;
  margin: 10px;
  cursor: pointer;
  border: 1px solid #e5e5e5;
}

.image-style {
  display: grid;
  justify-content: center;
  padding: 7px 10px;
}

.title-name {
  display: flex;
  align-items: baseline;
  font-size: 15px;
}

.title-name img {
  width: 15px;
  height: 15px;
}

.nameSpan {
  margin-top: 7px;
  font-size: 18px;
  white-space: nowrap; /*强制span不换行*/
  display: inline-block; /*将span当做块级元素对待*/
  width: 100%; /*限制宽度*/
  overflow: hidden; /*超出宽度部分隐藏*/
  text-overflow: ellipsis; /*超出部分以点号代替*/
  /*line-height: 0.9;  !*数字与之前的文字对齐*!*/
}

:deep(.el-card__body) {
  height: 100%;
  overflow: auto;
  padding: 10px;
}

/*树相互之间的高度*/
/*:deep(.el-tree-node__content) {*/
/*  height: 32px;*/
/*}*/

.border {
  font-size: 36px;
  text-align: center;
  margin-top: 30px;
  border: 1px solid lightgrey;
  padding: 300px;
  width: 100%;
  height: 100%;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.mytree {
  margin-left: -15px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  // 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

  // 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 20px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.el-tree-node__expand-icon.is-leaf) {
    visibility: visible !important;
  }

  //:deep(.is-leaf) {
  //  //display: none; // 也可以去掉
  //  position: relative;
  //}

  :deep(.is-leaf)::before {
    content: ''; /* 必须有 content 属性 */
    position: absolute;
    top: 13.5px; /* 将横线定位在元素的中间 */
    left: 0;
    width: 100%;
    border-top: 1px dashed #b8b9bb; /* 虚线 */
    transform: translateY(-50%); /* 微调位置使其完全居中 */
  }
}

</style>